/**
 * useBrand — acesso à marca corrente (memoizado). Nunca hardcodar marca em componentes (§7.7).
 */
import { useMemo } from 'react';
import { getBrand, type Brand } from '../config/brand';

export function useBrand(): Brand {
  return useMemo(() => getBrand(), []);
}
